import React from "react";
import { connect } from "react-redux";
import RevitForgeViewer from "./parts/RevitForgeViewer";
import build from "../../../../assets/images/projects/building_gif.gif";
import FileViewer from "./parts/FileViewer";
import "./viewer.scss";
import { ErrorBoundary } from "react-error-boundary";
import { getForgePublicToken } from "../../../../actions";

/**
 * VIEWER - FORGER (rvt,pdf,dwg,dxf.. file) viewer and FILE (image files) viewer
 * @param {*} props
 * @returns
 */
const Viewer = (props) => {
	const {
		shareModelUrn = null,
		enableResize = true,
		viewerUrn,
		forgeFileNotSupportedMessage,
		previewLink,
		fileName,
		fileId,
	} = props;

	const renderViewer = () => {
		if (forgeFileNotSupportedMessage) {
			return <>{forgeFileNotSupportedMessage}</>;
		}

		const isPdf =
			typeof fileName === "string" && fileName.toLowerCase().endsWith(".pdf");

		if (previewLink && isPdf) {
			return (
				<FileViewer
					key={`file-${fileName}-${previewLink}`}
					previewLink={previewLink}
					name={fileName}
				/>
			);
		}

		if (shareModelUrn || viewerUrn) {
			return (
				<RevitForgeViewer
					key={`forge-${viewerUrn || shareModelUrn}`}
					enableResize={enableResize}
					viewerUrn={shareModelUrn || viewerUrn}
					fileId={fileId}
				/>
			);
		} else if (previewLink) {
			return (
				<FileViewer
					key={`file-${fileName}-${previewLink}`}
					previewLink={previewLink}
					name={fileName}
				/>
			);
		} else {
			return <img alt="Default gif" src={build}></img>;
		}
	};

	return (
		<ErrorBoundary FallbackComponent={() => <div>Error viewer!</div>}>
			<div
				className={`viewer  ${
					shareModelUrn || viewerUrn || previewLink ? "p-0" : " "
				}  text-center`}
			>
				{renderViewer()}
			</div>
		</ErrorBoundary>
	);
};

const mapStateToProps = (state, ownProps) => {
	const {
		jobView = false,
		isForPackage = false,
		fileId: ownPropsFileId,
	} = ownProps;
	let viewerUrn,
		fileName,
		previewLink,
		fileId,
		forgeFileNotSupportedMessage = null;

	if (jobView) {
		viewerUrn = state.getIn(["job", "bimModel", "viewerUrn"]);
		fileId = state.getIn(["job", "bimModel", "file", "id"]);
		fileName = state.getIn(["job", "bimModel", "fileName"]);
		previewLink = state.getIn(["job", "bimModel", "previewLink"]);
		forgeFileNotSupportedMessage = state.getIn([
			"job",
			"bimModel",
			"forgeFileNotSupportedMessage",
		]);
	} else if (isForPackage) {
		viewerUrn = state.getIn([
			"dashboard",
			"salesPackage",
			"revitModel",
			"forgeUrnPreviewLink",
		]);
		fileId = state.getIn(["dashboard", "salesPackage", "revitModel", "id"]);
	} else {
		viewerUrn = state.getIn(["building", "buildingViewer", "viewerUrn"]);
		fileName = state.getIn(["building", "buildingViewer", "fileName"]);
		previewLink = state.getIn(["building", "buildingViewer", "previewLink"]);
		forgeFileNotSupportedMessage = state.getIn([
			"building",
			"forgeFileNotSupportedMessage",
		]);
	}
	return {
		viewerUrn,
		fileName,
		previewLink,
		fileId: fileId ?? ownPropsFileId,
		forgeFileNotSupportedMessage,
	};
};

export default connect(mapStateToProps, { getForgePublicToken })(Viewer);
